import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import { loginSuccess } from "./slices/auth/login/reducer"; // <-- import this

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});

// ✅ Rehydrate Redux from localStorage before rendering
const savedAuthUser = localStorage.getItem("authUser");
if (savedAuthUser) {
  try {
    const parsedUser = JSON.parse(savedAuthUser);
    if (parsedUser?.accessToken && parsedUser?.data) {
      store.dispatch(loginSuccess(parsedUser.data)); // update Redux state
    }
  } catch (err) {
    console.error("Failed to parse saved auth user:", err);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App />
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
